module.exports = __webpack_public_path__ + "static/wa-c5c33e320bf0b244f9faf94d820a20a0.png";